import { Link } from '@tanstack/react-router'
import { Mail, Globe } from 'lucide-react'
import { GranGuardMark, GG_EMAIL } from './brand'
import { COMMUNITY_PARTNER } from '@/lib/community-partners'

/** Footer for the ungated GranGuard face. */
export default function GranGuardFooter() {
  return (
    <footer className={`text-white ${COMMUNITY_PARTNER?.slug === 'beekeeper' ? 'bg-[#17121f]' : 'bg-[#221a3d]'}`}>
      <div className="h-1 w-full bg-violet-600" />
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
          <GranGuardMark onDark className="h-9" />
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-base text-white/80">
            <a href={`mailto:${GG_EMAIL}`} className="inline-flex items-center gap-2 hover:text-white">
              <Mail className="h-4 w-4 text-violet-300" />
              {GG_EMAIL}
            </a>
            <a href="https://granguard.org" className="inline-flex items-center gap-2 hover:text-white">
              <Globe className="h-4 w-4 text-violet-300" />
              granguard.org
            </a>
          </div>
        </div>
        {COMMUNITY_PARTNER && (
          <div className="mt-8 flex flex-col gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3">
              <img
                src={COMMUNITY_PARTNER.logoUrl}
                alt={COMMUNITY_PARTNER.logoAlt}
                className="h-10 w-10 rounded-full bg-white/90 object-contain p-0.5"
                width={40}
                height={40}
              />
              <div className="text-base">
                <p className="font-semibold text-white">{COMMUNITY_PARTNER.name}</p>
                <p className="text-white/60">{COMMUNITY_PARTNER.organization}</p>
              </div>
            </div>
            {(COMMUNITY_PARTNER.address || COMMUNITY_PARTNER.phone || COMMUNITY_PARTNER.website) && (
              <div className="text-base text-white/70">
                {COMMUNITY_PARTNER.address && <p>{COMMUNITY_PARTNER.address.join(', ')}</p>}
                <p>
                  {COMMUNITY_PARTNER.phone && COMMUNITY_PARTNER.tel && (
                    <a href={`tel:${COMMUNITY_PARTNER.tel}`} className="hover:text-white">{COMMUNITY_PARTNER.phone}</a>
                  )}
                  {COMMUNITY_PARTNER.phone && COMMUNITY_PARTNER.website && ' · '}
                  {COMMUNITY_PARTNER.website && (
                    <a href={COMMUNITY_PARTNER.website} target="_blank" rel="noopener noreferrer" className="hover:text-white">
                      {COMMUNITY_PARTNER.websiteLabel ?? COMMUNITY_PARTNER.website}
                    </a>
                  )}
                </p>
              </div>
            )}
          </div>
        )}
        <div className="mt-8 flex flex-col gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-white/50">
            &copy; {new Date().getFullYear()} GranGuard. Educational content. Not legal or financial advice.
          </p>
          <div className="flex items-center gap-5 text-sm text-white/60">
            <Link to="/privacy" className="hover:text-white">
              Privacy
            </Link>
            <Link to="/about" className="hover:text-white">
              About
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
